import {reducer} from './helpers'
import {
  CANCEL_PARTICIPANT_ORDER_SUCCESS,
  CLEAR_EVENT_AND_ORDER_DETAILS,
  EDIT_PARTICIPANT_SUCCESS,
  GET_EVENT_AND_ORDER_DETAILS_FAILURE,
  GET_EVENT_AND_ORDER_DETAILS_PENDING,
  GET_EVENT_AND_ORDER_DETAILS_SUCCESS,
  HIDE_SUCCESS_MESSAGE_BAR,
  SHOW_SUCCESS_MESSAGE_BAR,
  START_FORM_PROCESSING,
  STOP_FORM_PROCESSING,
  UPDATE_CURRENT_PAGE_DETAILS,
} from '../actions/eventMgr'

const initialState = {
  details: {},
  formIsProcessing: false,
  hasError: false,
  successMsgBarVisible: false,
  currentPageDetails: {
    orderId: null,
  },
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case CANCEL_PARTICIPANT_ORDER_SUCCESS: {
      const {eventLook, userId} = action.payload
      const updatedOrders = state.details.orders.filter((order) => order.userId !== userId)
      const updatedEventLooks = state.details.event.eventLooks.map((look) => {
        if (look.id !== eventLook) {
          return look
        }
        return {
          ...look,
          participantIds: look.participantIds.filter((id) => id !== userId),
          participants: look.participants.filter(({id}) => id !== userId),
        }
      })
      return {
        ...state,
        details: {
          event: {
            ...state.details.event,
            eventLooks: updatedEventLooks,
          },
          orders: updatedOrders,
        },
      }
    }
    case CLEAR_EVENT_AND_ORDER_DETAILS:
      return {
        details: {},
      }
    case EDIT_PARTICIPANT_SUCCESS: {
      const {newParticipant, prevLookId, prevOrderId, prevUserId} = action.payload
      const newOrders = state.details.orders.map((order) => {
        if (order.id !== prevOrderId) {
          return order
        }
        return {
          ...order,
          emailAddress: newParticipant.participant.email,
          id: newParticipant.orderId,
          userId: newParticipant.participant.id,
        }
      })
      const newEventLooks = state.details.event.eventLooks.map((look) => {
        if (look.id !== prevLookId) {
          return look
        }
        const newParticipants = look.participants.map((participant) => {
          if (participant.id !== prevUserId) {
            return participant
          }
          return {
            ...participant,
            email: newParticipant.participant.email,
            id: newParticipant.participant.id,
          }
        })
        const newParticipantIds = look.participantIds.map((id) => {
          if (id !== prevUserId) {
            return id
          }
          return newParticipant.participant.id
        })
        return {
          ...look,
          participantIds: newParticipantIds,
          participants: newParticipants,
        }
      })
      return {
        ...state,
        details: {
          event: {
            ...state.details.event,
            eventLooks: newEventLooks,
          },
          orders: newOrders,
        },
      }
    }
    case GET_EVENT_AND_ORDER_DETAILS_FAILURE:
      return {
        hasError: true,
      }
    case GET_EVENT_AND_ORDER_DETAILS_PENDING:
      return {
        hasError: false,
      }
    case GET_EVENT_AND_ORDER_DETAILS_SUCCESS:
      return {
        details: action.payload,
        hasError: false,
      }
    case HIDE_SUCCESS_MESSAGE_BAR:
      return {
        successMsgBarVisible: false,
      }
    case SHOW_SUCCESS_MESSAGE_BAR:
      return {
        successMsgBarVisible: true,
      }
    case START_FORM_PROCESSING:
      return {
        formIsProcessing: true,
      }
    case STOP_FORM_PROCESSING:
      return {
        formIsProcessing: false,
      }
    case UPDATE_CURRENT_PAGE_DETAILS: {
      const {orderId} = action.payload
      return {
        currentPageDetails: {
          orderId,
        },
      }
    }
    default:
      return null
  }
})
